import React, { FC } from "react";
import { Stack, Typography } from "@mui/material";
import HubspotGenericForm from "../GenericForm";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";
import ReactMarkdown from "react-markdown";

interface HubspotStyledFormProps {
  region?: string;
  portalId?: string;
  formId: string;
  headerText?: string;
  subText?: string;
}

const HubspotStyledForm: FC<HubspotStyledFormProps> = ({
  region = "na1",
  portalId = "21503852",
  headerText = "",
  subText = "",
  formId,
}) => {
  return (
    <Stack
      sx={{
        border: `solid 1px ${Colors.BorderDefault}`,
        borderRadius: "8px",
        width: "100%",
        maxWidth: "750px",
        marginX: "auto",
        padding: "20px",
        marginY: "24px",
        gap: "10px",
      }}
    >
      {headerText.trim() !== "" ? (
        <Typography variant="h5">{headerText}</Typography>
      ) : (
        ""
      )}

      {subText.trim() !== "" ? (
        <Typography variant="body1">
          <ReactMarkdown children={subText} />
        </Typography>
      ) : (
        ""
      )}

      <HubspotGenericForm region={region} portalId={portalId} formId={formId} />
    </Stack>
  );
};

export default HubspotStyledForm;
